"use client"
import { useTheme as useNextThemes } from "next-themes"
import { useCallback, useEffect, useMemo, useState } from "react"
import { LIGHT, DARK, type Theme } from "@/lib/theme"

export function useTheme() {
  const { resolvedTheme, setTheme, theme } = useNextThemes()

  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  const isDark = mounted && resolvedTheme === "dark"

  const t: Theme = useMemo(() => (isDark ? DARK : LIGHT), [isDark])

  const toggle = useCallback(() => {
    setTheme(isDark ? "light" : "dark")
  }, [isDark, setTheme])

  return { isDark, t, toggle, theme, setTheme }
}
